import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const PrivacyPolicyPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-lg shadow-lg p-8 md:p-12"
        >
          <h1 className="text-4xl font-bold text-gray-800 mb-8 border-b pb-4">
            {t('privacy.title')}
          </h1>

          <div className="space-y-8 text-gray-700">
            {/* Introduction */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.intro')}
              </h2>
              <p className="mb-4">
                {t('privacy.introText1')}
              </p>
              <p>
                {t('privacy.introText2')}
              </p>
            </section>

            {/* What Data We Collect */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.dataCollection')}
              </h2>
              <div className="mb-4">
                <h3 className="text-lg font-semibold mb-2">{t('privacy.contactForms')}</h3>
                <ul className="list-disc pl-5 space-y-1">
                  {(t('privacy.contactFormsList', { returnObjects: true }) || []).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold mb-2">{t('privacy.websiteUsage')}</h3>
                <ul className="list-disc pl-5 space-y-1">
                  {(t('privacy.websiteUsageList', { returnObjects: true }) || []).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </section>

            {/* How We Use Your Data */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.dataUse')}
              </h2>
              <p className="mb-4">
                {t('privacy.dataUseText')}
              </p>
              <ul className="list-disc pl-5 space-y-2">
                {(t('privacy.dataUseList', { returnObjects: true }) || []).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            {/* Data Sharing */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.dataSharing')}
              </h2>
              <p className="mb-4">
                {t('privacy.dataSharingText')}
              </p>
              <ul className="list-disc pl-5 space-y-2">
                {(t('privacy.dataSharingList', { returnObjects: true }) || []).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>

            {/* Data Storage */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.dataStorage')}
              </h2>
              <p className="mb-4">
                {t('privacy.dataStorageText1')}
              </p>
              <p>
                {t('privacy.dataStorageText2')}
              </p>
            </section>

            {/* Your Rights */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.yourRights')}
              </h2>
              <p className="mb-4">
                {t('privacy.yourRightsText')}
              </p>
              <ul className="list-disc pl-5 space-y-2">
                {(t('privacy.yourRightsList', { returnObjects: true }) || []).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <p>
                {t('privacy.yourRightsFooter')}
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.cookies')}
              </h2>
              <p className="mb-4">
                {t('privacy.cookiesText1')}
              </p>
              <p>
                {t('privacy.cookiesText2')}
              </p>
            </section>

            {/* Contact Information */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.contactInfo')}
              </h2>
              <p className="mb-2">
                {t('privacy.contactInfoText')}
              </p>
              <p className="mb-2">
                <strong>Olof Berglund</strong><br />
                  <strong>Svansele Grönt</strong><br />
                Svansele 2<br />
                936 93 Boliden<br />
                Sverige
              </p>
              <p className="mb-2">
                {t('contact.email')}: <a href="mailto:svanselemajeri@norsjo.nu" className="text-accent-green hover:underline">svanselemajeri@norsjo.nu</a>
              </p>
              <p>
                {t('contact.phone')}: +46 (0)70 637 93 14 
              </p>
            </section>

            {/* Changes to Policy */}
            <section>
              <h2 className="text-2xl font-semibold text-primary-green mb-4">
                {t('privacy.changes')}
              </h2>
              <p>
                {t('privacy.changesText1')}
              </p>
              <p className="mt-2">
                <em>{t('privacy.changesText2')} {new Date().toLocaleDateString('sv-SE')}</em>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;